(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/init.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/init.js');
'use strict';

const {
  SelfExclusionMain,
  SelfExclusionNotPLayer
} = svs.selfExclusion.components;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
svs.selfExclusion.init = () => {
  ReactDOM.render(React.createElement(ErrorBoundary, null, isLoggedIn ? React.createElement(SelfExclusionMain, null) : React.createElement(SelfExclusionNotPLayer, null)), document.getElementsByClassName('js-react-container')[0]);
};
svs.selfExclusion.init();

 })(window);